import type { Place } from '../types/place'
import { placesMini } from './placesMini'

export type PassTier = 'mini' | 'full'

const FULL_KWOTA = '60'

/** Treść współdzielona z katalogiem Mini (osobne rekordy Full). */
const miniCloneSource: Record<string, Place> = {
  'park-bukowcu': placesMini.find((p) => p.id === 1)!,
  lubiaz: placesMini.find((p) => p.id === 2)!,
  'zalew-mietkow': placesMini.find((p) => p.id === 9)!,
}

type FullPlaceSeed = {
  id: number
  name: string
  category: string
  region: string
  description: string
  locationLabel: string
  lat: number
  lng: number
  /** Sklonuj artykuł, zdjęcia i szczegóły z Mini. */
  miniClone?: keyof typeof miniCloneSource
  comingSoon?: boolean
}

const fullPlaceSeeds: FullPlaceSeed[] = [
  {
    id: 1,
    name: 'Ogród Botaniczny Uniwersytetu Wrocławskiego',
    category: 'Ogród / nauka',
    region: 'Wrocław',
    description: 'Jeden z najstarszych ogrodów botanicznych w Polsce — szklarnie, alejki i kolekcje roślin w sercu Wrocławia.',
    locationLabel: 'Wrocław, ul. Sienkiewicza',
    lat: 51.1167,
    lng: 17.0517,
  },
  {
    id: 2,
    name: 'Hala Stulecia i Pawilon Czterech Kopuł',
    category: 'Architektura / UNESCO',
    region: 'Wrocław',
    description: 'Ikona modernizmu i dziedzictwo UNESCO — Hala Stulecia oraz Pawilon Czterech Kopuł przy Pergoli.',
    locationLabel: 'Wrocław, Wystawowa',
    lat: 51.1069,
    lng: 17.0774,
  },
  {
    id: 3,
    name: 'Panorama Racławicka',
    category: 'Muzeum / sztuka',
    region: 'Wrocław',
    description: 'Monumentalne malowidło rotundowe — wizyta w otoczeniu historii bitwy pod Racławicami.',
    locationLabel: 'Wrocław, Purkyniego',
    lat:  51.1109,
    lng: 17.0473,
  },
  {
    id: 4,
    name: 'Hydropolis',
    category: 'Centrum edukacyjne',
    region: 'Wrocław',
    description: 'Interaktywne centrum wiedzy o wodzie — ekspozycje, multimedialne strefy i lekcja ekologii.',
    locationLabel: 'Wrocław, Na Grobli',
    lat: 51.1042,
    lng: 17.0456,
  },
  {
    id: 5,
    name: 'Muzeum Narodowe we Wrocławiu',
    category: 'Muzeum',
    region: 'Wrocław',
    description: 'Jedno z najważniejszych muzeów sztuki w Polsce — malarstwo, rzeźba i wystawy czasowe.',
    locationLabel: 'Wrocław, plac Powstańców Warszawy',
    lat: 51.1108,
    lng: 17.0465,
  },
  {
    id: 6,
    name: 'Ostrów Tumski (Muzeum Archidiecezjalne)',
    category: 'Historia / sakralne',
    region: 'Wrocław',
    description: 'Najstarsza część Wrocławia z katedrą i Muzeum Archidiecezjalnym — klimat średniowiecznych uliczek.',
    locationLabel: 'Wrocław, Ostrów Tumski',
    lat: 51.1144,
    lng: 17.0419,
  },
  {
    id: 7,
    name: 'Masyw Ślęży (Dom Turysty PTTK)',
    category: 'Góry / przyroda',
    region: 'Masyw Ślęży',
    description: 'Ślęża i okolice — szlaki, widoki i punkt startowy przy Domu Turysty PTTK na Przełęczy Tąpadła.',
    locationLabel: 'Przełęcz Tąpadła / Ślęża',
    lat: 50.8647,
    lng: 16.7122,
  },
  {
    id: 8,
    name: 'Śnieżka (KPN / Dom Śląski)',
    category: 'Góry',
    region: 'Karkonosze',
    description: 'Najwyższy szczyt Sudetów — wejście na Śnieżkę i schronisko Dom Śląski w Karkonoszach.',
    locationLabel: 'Karkonosze, Śnieżka',
    lat: 50.7361,
    lng: 15.7394,
  },
  {
    id: 9,
    name: 'Świątynia Wang w Karpaczu',
    category: 'Zabytek / sakralne',
    region: 'Karkonosze',
    description: 'Norweska świątynia z XII wieku przeniesiona w Karkonosze — unikalny zabytek na szlaku.',
    locationLabel: 'Karpacz, Świątynia Wang',
    lat: 50.7794,
    lng: 15.7217,
  },
  {
    id: 10,
    name: 'Wodospad Kamieńczyka',
    category: 'Przyroda',
    region: 'Karkonosze',
    description: 'Najwyższy wodospad polskich Sudetów — kaskady Kamieńczyka w Karkonoszach.',
    locationLabel: 'Szklarska Poręba, Karkonosze',
    lat: 50.7803,
    lng: 15.6058,
  },
  {
    id: 11,
    name: 'Wodospad Szklarki',
    category: 'Przyroda',
    region: 'Karkonosze',
    description: 'Malowniczy wodospad przy szlaku w Szklarskiej Porębie — łatwy dostęp z centrum miasta.',
    locationLabel: 'Szklarska Poręba',
    lat: 50.8278,
    lng: 15.5578,
  },
  {
    id: 12,
    name: 'Zamek Chojnik',
    category: 'Zamek / ruiny',
    region: 'Karkonosze',
    description: 'Ruiny zamku na górze Chojnik — widok na Kotlinę Jeleniogórską i wspinaczka z Sobieszowa.',
    locationLabel: 'Sobieszów / Chojnik',
    lat: 50.8722,
    lng: 15.6442,
  },
  {
    id: 13,
    name: 'Park w Bukowcu (Fundacja Doliny Pałaców)',
    category: 'Park / ogród',
    region: 'Kotlina Jeleniogórska',
    description: 'Romantyczny park krajobrazowy u stóp Śnieżki — stawy, alejki i widoki na Karkonosze.',
    locationLabel: 'Bukowiec, Kotlina Jeleniogórska',
    lat: 50.826,
    lng: 15.852,
    miniClone: 'park-bukowcu',
  },
  {
    id: 14,
    name: 'Pałac w Wojanowie',
    category: 'Pałac',
    region: 'Kotlina Jeleniogórska',
    description: 'Zespół pałacowy w Dolinie Pałaców — historia arystokracji i spacer po otoczeniu parku.',
    locationLabel: 'Wojanów',
    lat: 50.8597,
    lng: 15.8225,
  },
  {
    id: 15,
    name: 'Wieża Książęca w Siedlęcinie',
    category: 'Zabytek / średniowiecze',
    region: 'Kotlina Jeleniogórska',
    description: 'Średniowieczna wieża mieszkalna z unikalnymi malowidłami ściennymi — rzadki zabytek na mapie regionu.',
    locationLabel: 'Siedlęcin',
    lat: 50.8183,
    lng: 15.6061,
  },
  {
    id: 16,
    name: 'Zapora w Pilchowicach',
    category: 'Inżynieria / przyroda',
    region: 'Góry Izerskie',
    description: 'Jedna z największych zapór w Polsce — jezioro i widok na konstrukcję z początku XX wieku.',
    locationLabel: 'Pilchowice',
    lat: 51.0436,
    lng: 15.3844,
  },
  {
    id: 17,
    name: 'Wysoki Kamień w Szklarskiej Porębie',
    category: 'Punkt widokowy',
    region: 'Karkonosze',
    description: 'Skała z platformą widokową nad Szklarską Porębą — krótka, efektowna wycieczka w Karkonosze.',
    locationLabel: 'Szklarska Poręba',
    lat: 50.8156,
    lng: 15.5297,
  },
  {
    id: 18,
    name: 'Uzdrowisko Świeradów-Zdrój',
    category: 'Uzdrowisko / architektura',
    region: 'Góry Izerskie',
    description: 'Zdrojowy kurort u podnóża Izera — pijalnia wód, deptak i klimat górskiego uzdrowiska.',
    locationLabel: 'Świeradów-Zdrój',
    lat: 50.9047,
    lng: 15.3392,
  },
  {
    id: 19,
    name: 'Kopalnia Uranu w Kletnie',
    category: 'Muzeum / kopalnia',
    region: 'Masyw Śnieżnika',
    description: 'Podziemna trasa edukacyjna w dawnej kopalni — historia górnictwa i Kletno w Masywie Śnieżnika.',
    locationLabel: 'Kletno',
    lat: 50.2303,
    lng: 16.8581,
  },
  {
    id: 20,
    name: 'Szczeliniec Wielki',
    category: 'Przyroda / skały',
    region: 'Góry Stołowe',
    description: '„Piekło” i labirynt skalnych formacji na Szczelincu — obowiązkowy punkt Gór Stołowych.',
    locationLabel: 'Karłów, Góry Stołowe',
    lat: 50.4853,
    lng: 16.5642,
  },
  {
    id: 21,
    name: 'Błędne Skały',
    category: 'Przyroda / skały',
    region: 'Góry Stołowe',
    description: 'Skalny labirynt w Parku Narodowym Gór Stołowych — wąskie przejścia i formacje piaskowcowe.',
    locationLabel: 'Góry Stołowe',
    lat: 50.4247,
    lng: 16.37,
  },
  {
    id: 22,
    name: 'Krzywa Wieża w Ząbkowicach Śląskich',
    category: 'Zabytek',
    region: 'Ząbkowice Śląskie',
    description: 'Średniowieczna krzywa wieża — jedna z najbardziej rozpoznawalnych atrakcji na południowym Dolnośląsku.',
    locationLabel: 'Ząbkowice Śląskie',
    lat: 50.5897,
    lng: 16.8125,
  },
  {
    id: 23,
    name: 'Kaplica Czaszek w Czermnej',
    category: 'Zabytek / sakralne',
    region: 'Kudowa-Zdrój',
    description: 'Kaplica z czaszkami i kośćmi — mroczna, ale fascynująca lekcja historii regionu.',
    locationLabel: 'Czermna, Kudowa-Zdrój',
    lat: 50.3831,
    lng: 16.5636,
  },
  {
    id: 24,
    name: 'Muzeum Papiernictwa w Dusznikach-Zdroju',
    category: 'Muzeum',
    region: 'Kłodzko',
    description: 'Historia papieru i dawna manufaktura — interaktywne ekspozycje w zdrojowym Dusznikach.',
    locationLabel: 'Duszniki-Zdrój',
    lat: 50.4006,
    lng: 16.3925,
  },
  {
    id: 25,
    name: 'Dawna Kopalnia w Nowej Rudzie',
    category: 'Muzeum / kopalnia',
    region: 'Masyw Śnieżnika',
    description: 'Podziemna trasa w dawnej kopalni — poznaj historię górnictwa w Nowej Rudzie.',
    locationLabel: 'Nowa Ruda',
    lat: 50.5808,
    lng: 16.5922,
  },
  {
    id: 26,
    name: 'Torfowisko pod Zieleńcem',
    category: 'Przyroda / rezerwat',
    region: 'Góry Bystrzyckie',
    description: 'Wysokie torfowisko i szlaki w Górach Bystrzyckich — cisza, wrzosowiska i widoki.',
    locationLabel: 'Zieleniec, Góry Bystrzyckie',
    lat: 50.3864,
    lng: 16.4531,
  },
  {
    id: 27,
    name: 'Pałac Gorzanów',
    category: 'Pałac',
    region: 'Kłodzko',
    description: 'Barokowy pałac z otaczającym parkiem — perła Dolnego Śląska w Kotlinie Kłodzkiej.',
    locationLabel: 'Gorzanów',
    lat: 50.3644,
    lng: 16.7767,
  },
  {
    id: 28,
    name: 'Zamek Sarny (Ścinawka Górna)',
    category: 'Zamek',
    region: 'Kłodzko',
    description: 'Zamek i pałac w Ścinawce Górnej — spacer po dziedzińcach i historii rodu Hochbergów.',
    locationLabel: 'Ścinawka Górna',
    lat: 50.4767,
    lng: 16.45,
  },
  {
    id: 29,
    name: 'Zamek Książ w Wałbrzychu',
    category: 'Zamek',
    region: 'Wałbrzych',
    description: 'Trzeci co do wielkości zamek w Polsce — tarasy, ogrody i tajemnice Wałbrzycha.',
    locationLabel: 'Wałbrzych, Książ',
    lat: 50.8422,
    lng: 16.2919,
  },
  {
    id: 30,
    name: 'Stara Kopalnia w Wałbrzychu',
    category: 'Muzeum / kopalnia',
    region: 'Wałbrzych',
    description: 'Centrum Nauki i Sztuki w zabytkowej kopalni — podziemna trasa i industrialny klimat.',
    locationLabel: 'Wałbrzych',
    lat: 50.7694,
    lng: 16.2833,
  },
  {
    id: 31,
    name: 'Kompleks Riese – Osówka',
    category: 'Historia / podziemia',
    region: 'Góry Sowie',
    description: 'Podziemny kompleks Osówka — tajemnicza historia Projektu Riese w Górach Sowich.',
    locationLabel: 'Głuszyca, Osówka',
    lat: 50.6806,
    lng: 16.3897,
  },
  {
    id: 32,
    name: 'Kompleks Riese – Włodarz',
    category: 'Historia / podziemia',
    region: 'Góry Sowie',
    description: 'Jedna z największych podziemnych tras Riese — militarna historia pod Górami Sowimi.',
    locationLabel: 'Głuszyca, Włodarz',
    lat: 50.6894,
    lng: 16.4458,
  },
  {
    id: 33,
    name: 'Kompleks Riese – Sztolnie Walimskie',
    category: 'Historia / podziemia',
    region: 'Góry Sowie',
    description: 'Podziemna trasa w Sztolniach Walimskich — kolejny rozdział historii Riese.',
    locationLabel: 'Walim',
    lat: 50.6497,
    lng: 16.4531,
  },
  {
    id: 34,
    name: 'Zamek Grodno w Zagórzu Śląskim',
    category: 'Zamek',
    region: 'Góry Sowie',
    description: 'Zamek nad Jeziorem Bystrzyckim — widok na wodę i górskie otoczenie.',
    locationLabel: 'Zagórze Śląskie',
    lat: 50.4242,
    lng: 16.3961,
  },
  {
    id: 35,
    name: 'Kościół Pokoju w Świdnicy',
    category: 'UNESCO / sakralne',
    region: 'Świdnica',
    description: 'Drewniany kościół wpisany na listę UNESCO — symbol tolerancji religijnej na Śląsku.',
    locationLabel: 'Świdnica',
    lat: 50.8447,
    lng: 16.4886,
  },
  {
    id: 36,
    name: 'Zapora i Jezioro Bystrzyckie',
    category: 'Przyroda / jezioro',
    region: 'Góry Sowie',
    description: 'Zapora na Bystrzycy i rozległe Jezioro Bystrzyckie — raj dla spacerów i rowerów.',
    locationLabel: 'Zagórze Śląskie / Bystrzyca',
    lat: 50.6708,
    lng: 16.6339,
  },
  {
    id: 37,
    name: 'Wielka Sowa',
    category: 'Punkt widokowy',
    region: 'Góry Sowie',
    description: 'Najwyższy szczyt Gór Sowich z wieżą widokową — panorama Sudetów Środkowych.',
    locationLabel: 'Góry Sowie, Wielka Sowa',
    lat: 50.6811,
    lng: 16.4817,
  },
  {
    id: 38,
    name: 'Kolorowe Jeziorka w Rudawach Janowickich',
    category: 'Przyroda',
    region: 'Rudawy Janowickie',
    description: 'Tęczowe jeziora w dawnym kamieniołomie — krótka, kolorowa wycieczka w Rudawach.',
    locationLabel: 'Rudawy Janowickie',
    lat: 50.8419,
    lng: 15.9261,
  },
  {
    id: 39,
    name: 'Opactwo Cystersów w Lubiążu',
    category: 'Opactwo / zabytek',
    region: 'Dolnośląskie',
    description: 'Jedno z największych opactw cysterskich w Europie — barokowe wnętrza i ogromna historia.',
    locationLabel: 'Lubiąż',
    lat: 51.262889,
    lng: 16.461389,
    miniClone: 'lubiaz',
  },
  {
    id: 40,
    name: 'Bazylika i Opactwo w Krzeszowie',
    category: 'Opactwo / barok',
    region: 'Kamienna Góra',
    description: 'Perła baroku na Dolnym Śląsku — bazylika, freski i opactwo w Krzeszowie.',
    locationLabel: 'Krzeszów',
    lat: 50.7422,
    lng: 16.0708,
  },
  {
    id: 41,
    name: 'Kościół Pokoju w Jaworze',
    category: 'UNESCO / sakralne',
    region: 'Jawor',
    description: 'Największy drewniany kościół w Europie — wpisany na listę UNESCO w Jaworze.',
    locationLabel: 'Jawor',
    lat: 51.0542,
    lng: 16.1936,
  },
  {
    id: 42,
    name: 'Zamek w Bolkowie',
    category: 'Zamek',
    region: 'Bolków',
    description: 'Średniowieczny zamek na wzgórzu — festiwale, widoki i historia Piastów.',
    locationLabel: 'Bolków',
    lat: 50.9222,
    lng: 16.1011,
  },
  {
    id: 43,
    name: 'Domy Tkaczy w Chełmsku Śląskim',
    category: 'Architektura / UNESCO',
    region: 'Kamienna Góra',
    description: 'Zespół domów tkaczy — unikalna, drewniana architektura wpisana na listę UNESCO.',
    locationLabel: 'Chełmsko Śląskie',
    lat: 50.7061,
    lng: 16.0661,
  },
  {
    id: 44,
    name: 'Rezerwat Wąwóz Myśliborski',
    category: 'Przyroda / rezerwat',
    region: 'Kamienna Góra',
    description: 'Wąwóz z potokiem i lasem — krótka, ale bardzo klimatyczna trasa w rezerwacie.',
    locationLabel: 'Myślibórz, Kamienna Góra',
    lat: 50.5833,
    lng: 16.75,
  },
  {
    id: 45,
    name: 'Ostrzyca Proboszczowicka',
    category: 'Góry / przyroda',
    region: 'Pogórze Kaczawskie',
    description: '„Sudecka Fudżijama” — charakterystyczna góra z pięknymi widokami na Pogórze Kaczawskie.',
    locationLabel: 'Proboszczowice',
    lat: 51.0139,
    lng: 16.7667,
  },
  {
    id: 46,
    name: 'Stawy Milickie (Naturum)',
    category: 'Przyroda / ptaki',
    region: 'Milicz',
    description: '„Polskie Biebrza” — rozlewiska, ptaki i centrum edukacji Naturum przy Stawach Milickich.',
    locationLabel: 'Milicz, Stawy Milickie',
    lat: 51.5167,
    lng: 17.3,
  },
  {
    id: 47,
    name: 'Perła Żeliszowa',
    category: 'Przyroda / jezioro',
    region: 'Żelazno',
    description: 'Czyste, górskie jezioro otoczone lasem — spokojna przerwa w Pogórzu Kaczawskim.',
    locationLabel: 'Żelazno',
    lat: 50.9,
    lng: 17.1833,
  },
  {
    id: 48,
    name: 'Zalew Mietków',
    category: 'Jezioro / rekreacja',
    region: 'Wrocław i okolice',
    description: 'Jezioro rekreacyjne pod Wrocławiem — plaże, ścieżki i wypoczynek nad wodą.',
    locationLabel: 'Mietków',
    lat: 50.95861,
    lng: 16.74889,
    miniClone: 'zalew-mietkow',
  },
]

/** Rezerwa pod rozszerzenie katalogu do 60 miejsc w produkcie. */
const fullComingSoonSeeds: FullPlaceSeed[] = Array.from({ length: 12 }, (_, i) => ({
  id: 49 + i,
  name: `Miejsce ${49 + i}`,
  category: 'Wkrótce',
  region: 'Dolny Śląsk',
  description: 'Kolejne miejsce pełnego Paszportu — szczegóły uzupełnimy wkrótce.',
  locationLabel: 'Dolny Śląsk',
  lat: 51.1,
  lng: 17.0,
  comingSoon: true,
}))

function buildFullPlace(seed: FullPlaceSeed): Place {
  if (seed.miniClone) {
    const source = miniCloneSource[seed.miniClone]
    if (source) {
      return {
        ...source,
        id: seed.id,
        name: seed.name,
        category: seed.category,
        region: seed.region,
        description: seed.description,
        locationLabel: seed.locationLabel,
        lat: seed.lat,
        lng: seed.lng,
        comingSoon: false,
        seo: source.seo
          ? {
              ...source.seo,
              title: seed.name,
              description: seed.description,
            }
          : {
              title: seed.name,
              description: seed.description,
              keywords: [seed.region, 'Dolny Śląsk', 'Paszport Dolnego Śląska'],
            },
      }
    }
  }

  const comingSoon = seed.comingSoon === true

  return {
    id: seed.id,
    name: seed.name,
    category: seed.category,
    region: seed.region,
    description: seed.description,
    longDescription: comingSoon
      ? 'To miejsce dołączymy wkrótce do pełnego Paszportu (60 miejsc).'
      : seed.description,
    comingSoon,
    article: comingSoon
      ? { published: false, sections: [] }
      : {
          published: true,
          intro: seed.description,
          sections: [
            {
              id: 'o-miejscu',
              title: 'O miejscu',
              body: `${seed.name} to jedno z 60 miejsc pełnego Paszportu Dolnego Śląska. Odwiedź ${seed.locationLabel}, zbierz pieczątkę i dodaj wpis do dziennika.`,
            },
          ],
        },
    highlights: comingSoon ? ['Wkrótce w pełnym Paszporcie'] : [seed.region, seed.category],
    practicalInfo: {
      visitDuration: comingSoon ? '—' : '2–4 godziny (zależnie od trasy).',
      howToGetThere: comingSoon ? 'Szczegóły wkrótce.' : `Dojazd do: ${seed.locationLabel}.`,
    },
    seo: {
      title: seed.name,
      description: seed.description,
      keywords: [seed.name, seed.region, 'Dolny Śląsk', 'Paszport Dolnego Śląska'],
    },
    locationLabel: seed.locationLabel,
    lat: seed.lat,
    lng: seed.lng,
  }
}

export const placesFull: Place[] = [...fullPlaceSeeds, ...fullComingSoonSeeds].map(buildFullPlace)

/** Klucze miniClone → id miejsca w katalogu Mini (Edycja 2026). */
const MINI_CLONE_KEY_TO_MINI_PLACE_ID: Record<keyof typeof miniCloneSource, number> = {
  'park-bukowcu': 1,
  lubiaz: 2,
  'zalew-mietkow': 9,
}

/** Pieczątka z Edycji 2026 (mini id) → to samo miejsce w pełnym katalogu (full id). */
export const MINI_EDITION_TO_FULL_PLACE_IDS: Record<number, number> = Object.fromEntries(
  fullPlaceSeeds
    .filter((s): s is FullPlaceSeed & { miniClone: keyof typeof miniCloneSource } => Boolean(s.miniClone))
    .map((s) => [MINI_CLONE_KEY_TO_MINI_PLACE_ID[s.miniClone], s.id]),
)

export const PLACES_COUNT_FULL = placesFull.length
export const FULL_PLACES_PUBLISHED_COUNT = placesFull.filter((p) => !p.comingSoon).length
export const FULL_PASS_KWOTA = FULL_KWOTA
